<template>
    <div>
        <CList :pConfigList="ConfigList" :segurity="segurity">
            <template slot="bodyForm">
                <CLoader :pConfigLoad="ConfigLoad">
                    <template slot="BodyFormLoad">
                        <div class="container-fluid">
                            <form id="FormSolicitudSalidaExtra" role="form" method="post" autocomplete="off" onSubmit="return false">
                                <div class="form-group row">
                                    <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
										<label class="form-label" for="FolioCot">Cotización</label>
										<input disabled type="text" class="form-control" v-model="ObjCotizacion.Folio"/>
									</div>
									<div class="col-12 col-sm-12 col-md-8 col-lg-8 col-xl-8">
										<label class="form-label" for="Cliente">Clientes</label>
										<input disabled type="text" class="form-control" v-model="ObjCotizacion.Nombres"/>
									</div>
                                </div>

                                <div class="form-group row">
									<div class="col-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
										<label class="form-label" for="TipoEvento">Tipo de Evento</label>
										<input disabled type="text" class="form-control" v-model="ObjCotizacion.TipoEvento.Nombre"/>
									</div>

									<div class="col-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
										<label class="form-label" for="FechaBoda">Fecha Principal</label>
										<input disabled type="text" class="form-control" v-model="ObjCotizacion.FechaBoda"/>
									</div>

									<div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
										<label class="form-label" for="FechaBoda">Ejecutivo Asignado</label>
										<input disabled type="text" class="form-control" v-model="Vendedor"/>
									</div>

									<div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
										<label class="form-label" for="FechaBoda">Personal del Hotal Asignado</label>
										<input disabled type="text" class="form-control" v-model="Contacto"/>
									</div>
								</div>

                                <div class="form-group row">
									<div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
										<label class="form-label" for="AgenteNombre">Hotel / Empresa</label>
										<input disabled type="text" class="form-control" v-model="ObjCotizacion.Agente.NombreComercial"/>
									</div>
								</div>

                                <div class="form-group row">
									<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
										<label class="form-label" for="Observaciones">Motivo de la Solicitud</label>
										<textarea v-model="ObjSolicitudSalidaExtra.Observaciones" name="" id="" cols="30" rows="2" placeholder="Motivo" class="form-control"></textarea>
									</div>
								</div>

                                <div class="form-group row">
									<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
										<h4>Actividades</h4>
										<ul class="nav nav-tabs" id="myTab" role="tablist">
											<li v-for="(item,index) in ListaEventos" :key="index" class="nav-item" role="presentation">
												<button type="button" :class="['nav-link', index == 0 ? 'active': '']" :id="'home-tab'+index" data-bs-toggle="tab" :data-bs-target="'#home-tab-pane'+index" role="tab" :aria-controls="'home-tab-pane'+index" :aria-selected="index == 0 ? 'true':'false'">Evento {{index+1}}</button>
											</li>
										</ul>

										<div class="tab-content" id="myTabContentCal">
											<div v-for="(item,index) in ListaEventos" :key="index" :class="['tab-pane fade scroll-ve',index == 0 ? 'show active': '']" :id="'home-tab-pane'+index" role="tabpanel" :aria-labelledby="'home-tab'+index" tabindex="0" style="max-height:400px !important">
												<div class="row">
													<div class="col-12 col-sm-12 col-md-12 col-lg-12">
														<label for="cmp8">Actividad</label>
														<input type="text" v-model="item.Evento" id="cmp8" class="form-control" readonly>
													</div>
												</div>
					
												<div class="row">

													<div class="col-12 col-sm-12 col-md-2 col-lg-2">
														<label for="cmp10">Fecha Montaje</label>
														<input type="text" v-model="item.FechaMontaje" id="cmp10" class="form-control" readonly>
													</div>

													<div class="col-12 col-sm-12 col-md-2 col-lg-2">
														<label for="cmp13">Hora Montaje</label>
														<input type="text" v-model="item.HoraMontaje" id="cmp13" class="form-control" readonly>
													</div>
													
													<div class="col-12 col-sm-12 col-md-2 col-lg-2">
														<label for="cmp9">Fecha Evento</label>
														<input type="text" v-model="item.FechaEvento" id="cmp9" class="form-control" readonly>
													</div>

													<div class="col-12 col-sm-12 col-md-2 col-lg-2">
														<label for="cmp12">Hora Evento</label>
														<input type="text" v-model="item.HoraEvento" id="cmp12" class="form-control" readonly>
													</div>
													
													<div class="col-12 col-sm-12 col-md-2 col-lg-2">
														<label for="cmp11">Fecha DesMontaje</label>
														<input type="text" v-model="item.FechaDesmontaje" id="cmp11" class="form-control" readonly>
													</div>
					
													<div class="col-12 col-sm-12 col-md-2 col-lg-2">
														<label for="cmp14">Hora DesMontaje</label>
														<input type="text" v-model="item.HoraDesMontaje" id="cmp14" class="form-control" readonly>
													</div>
												</div>
					
												<div class="row">
													<div class="col-12 col-sm-12 col-md-6 col-lg-6">
														<label for="cmp15">Locación</label>
														<input type="text" v-model="item.Locacion" id="cmp15" class="form-control" readonly>
													</div>
					
													<div class="col-12 col-sm-12 col-md-6 col-lg-6">
														<label for="cmp16">Back Up</label>
														<input type="text" v-model="item.BackUp" id="cmp16" class="form-control" readonly>
													</div>
												</div>
					
												<div class="row">
													<div class="col-12 col-sm-12 col-md-12 col-lg-12">
														<label for="cmp17">Descripción</label>
														<textarea  v-model="item.Evento" id="cmp17" class="form-control" rows="2" readonly></textarea>
													</div>
												</div>
					
												<h5 class="mt-3">Elementos</h5>
					
												<div class="row pt-2">
													<div class="col-12 col-sm-12 col-md-12 col-lg-12">
														<div class="table-responsive pb-0">
															<table class="table mb-0">
																<thead>
																	<tr>
																		<th width="10%" :class="ClassTr">#</th>
																		<th width="25%" :class="'text-uppercase '+ClassTr">Imagen</th>
																		<th width="10%" :class="'text-uppercase '+ClassTr">Cantidad</th>
																		<th width="36%" :class="'text-uppercase '+ClassTr">Descripción</th>
																		<th width="29%" :class="'text-uppercase '+ClassTr">Notas</th>
																	</tr>
																</thead>
																<tbody>
																	<tr v-for="(list,index2) in item.Elementos" :key="index2">
																		<td>{{index2+1}}</td>
																		<!-- <td>
																			<div class="form-check">
																				<input type="checkbox" v-model="list.Check" :id="'chk'+index2" class="form-check-input">
																				<label class="form-check-label" :for="'chk'+index2">
																				</label>
																			</div>
																		</td> -->
																		<td>
																			<span v-if="list.Anexado != 1">
																				<span v-if="!list.Nomimagen">
																					<img src="@/assets/style/image/sin_imagen_180.jpg" width="100" height="110px">
																				</span>

																				<span v-else>
																					<img :src="RutaFile+list.UrlImagen+list.Nomimagen" width="100" height="110px">
																				</span>
																			</span>

																			<span v-else>
																				<img :src="RutaAnexada+list.UrlImagen+list.Nomimagen" width="100" height="110px">
																			</span>
																		</td>
																		<td>
																			<input type="text" v-model="list.Cantidad" class="form-control" readonly>
																		</td>
																		<td>
																			<textarea v-model="list.Descripcion" class="form-control" rows="5" readonly></textarea>
																		</td>
																		<td>
																			<textarea v-model="list.Notas" class="form-control" rows="5" readonly></textarea>
																		</td>
																	</tr>
																	<CSinRegistros :pContIF="item.Elementos.length" :pColspan="3"></CSinRegistros>
																</tbody>
															</table>
														</div>
													</div>
												</div>
					
											</div>
										</div>
									</div>
								</div>
								
                                <div class="form-group row">
									<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
										<h4>Almacen</h4>
										<nav>
											<div class="nav nav-tabs" id="nav-tab2" role="tablist">
												
												<button type="button" class="nav-link active" id="nav-herramientas-tab" data-bs-toggle="tab" data-bs-target="#nav-herramientas" role="tab" aria-controls="nav-herramientas" aria-selected="false">
													Herramientas
												</button>

												<button type="button" class="nav-link" id="nav-insumos-tab" data-bs-toggle="tab" data-bs-target="#nav-insumos" role="tab" aria-controls="nav-insumos" aria-selected="false">
													Insumos
												</button>
											</div>
										</nav>
	
										<div class="tab-content" id="nav-tabContent">
											<div class="tab-pane fade show active" id="nav-herramientas" role="tabpanel" aria-labelledby="nav-herramientas-tab">
												<Herramientas :pOrigen="'SolicitudExtra'" :pObjMovimientoAlmacen="ObjSolicitudSalidaExtra"></Herramientas>
											</div>

											<div class="tab-pane fade show" id="nav-insumos" role="tabpanel" aria-labelledby="nav-insumos-tab">
												<Insumos :pOrigen="'SolicitudExtra'" :pObjMovimientoAlmacen="ObjSolicitudSalidaExtra"></Insumos>
											</div>
										</div>
									</div>
								</div>
														
								<br>
								<div class="form-group row">
									<div class="col-12 col-sm-12 col-md-10 col-lg-10">
									</div>
									<div class="col-12 col-sm-12 col-md-2 col-lg-2">
										<label for="TipoGuardado">Forma de Guardar:</label>
										<select v-model="TipoGuardado" id="TipoGuardado" class="form-select">
											<option value="Temporal">Temporal</option>
											<option value="Definitivo">Definitivo</option>
										</select>
									</div>
								</div>
								<CBtnSave :poBtnSave="oBtnSave" />
                            </form>
                        </div>
                    </template>
                </CLoader>
            </template>
        </CList>

		<CModal :pConfigModal="ConfigModalHerramienta" :poBtnSave="oBtnSaveHerramienta">
            <template slot="Form">
                <HerramientasList :poBtnSave="oBtnSaveHerramienta"></HerramientasList>
            </template>
        </CModal>

		<CModal :pConfigModal="ConfigModalInsumo" :poBtnSave="oBtnSaveInsumo">
            <template slot="Form">
                <InsumosList :poBtnSave="oBtnSaveInsumo"></InsumosList>
            </template>
        </CModal>
    </div>
</template>

<script>
import Configs from '@/helpers/VarConfig.js';
import Calendar from '@/helpers/StaticComboBox.js';

import Herramientas from '@/views/modulos/almacen/solicitud/tabs/Herramientas.vue';
import HerramientasList from '@/views/modulos/almacen/solicitud/modales/Herramientas.vue';

import Insumos from '@/views/modulos/almacen/solicitud/tabs/Insumos.vue';
import InsumosList from '@/views/modulos/almacen/solicitud/modales/Insumos.vue';

const EmitEjecuta = 'seccionSolicitudAlmacen';
const EmitModalHerramienta = 'seccionModalHerramienta';
const EmitModalInsumo = 'seccionModalInsumo';

export default {
    name: 'FormSolicitudSalidaExtra',
    props: ['IdMovimientoAlmacen','IdCotizacion','FechaEvento','pObjAsociado'],
    components:{
        Herramientas, HerramientasList,Insumos, InsumosList
    },
    data() {
        return {
            ConfigList:{
                Title: 'Solicitud Extraoficial',
                IsModal: false,
                BtnReturnShow: true,
                BtnNewShow: false,
                ShowFiltros: false,
                ShowPaginador: false,
				ShowTitleFirst: false,
                TypeBody: 'Form',
				EmitSeccion: EmitEjecuta,
            },
            ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
            oBtnSave:{
                Toast: 0,
                IsModal: false,
                DisableBtn: false,
                ReturnRoute: 'solicitudalmacen',
                EmitSeccion: EmitEjecuta,
				ShowBtnSave: true
            },
			ConfigModalHerramienta:{
				ModalTitle: "Lista de Herramientas",
                ModalNameId: 'ModalForm2',
                EmitSeccion: EmitModalHerramienta,
				ModalSize:'lg'
			},
            oBtnSaveHerramienta:{
                Toast: 0,
                DisableBtn: false,
                EmitSeccion: EmitModalHerramienta,
            },
			ConfigModalInsumo:{
				ModalTitle: "Lista de Insumos",
                ModalNameId: 'ModalForm3',
                EmitSeccion: EmitModalInsumo,
				ModalSize: 'lg'
			},
			oBtnSaveInsumo:{
                Toast: 0,
                DisableBtn: false,
                EmitSeccion: EmitModalInsumo,
            },
            ObjSolicitudSalidaExtra: {
				IdMovimientoAlmacen: 0,
				IdCotizacion: 0,
				IdCliente: 0,
				IdContacto: 0,
				IdAgente: 0,
				IdEmpresa: 0,
				IdSucursal: 0,
				SalidaAsociada: 0,
				Folio: '',
				IdUserElabora: 0,
				IdUserAutoriza: 0,
				IdUserEntrega: 0,
				IdUserRecibe: 0,
				FechaEvento: '',
				FechaSalida: '',
				FechaRetorno: '',
				TipoSalida: '',
				Estatus: '',
				Observaciones: '',
				Materiales:[],
				Herramientas:[],
				Insumos:[]
            },
            StyleTh: Configs.stylesTable.StyleTh,
            StylePr: Configs.stylesTable.StylePr,
            StyleTd: Configs.stylesTable.StyleTd,
			ClassTr: 'text-green-black text-xxs font-weight-bolder opacity-7',
            ObjCotizacion:{
				TipoEvento:[],
				Agente:{},
			},
			Vendedor: '',
			Contacto: '',
            ListaEventos:[],
			RutaFile: '',
			RutaAnexada: '',
			Setpicker: Calendar.calendarSettings,
            segurity: {},
			//masks: { input: 'YYYY-MM-DD' }, // quitar sino lleva fecha 
            errorvalidacion: [],
			Emit: EmitEjecuta,
			DetallesSolicitud: [],
			TipoGuardado: 'Temporal'
        }
    },
    methods: {
        async Guardar()
		{
            this.errorvalidacion = [];
            this.oBtnSave.Toast = 0; 
            this.oBtnSave.DisableBtn = true;

			let BndError = false;
            let Mensaje = "";

			if (this.ObjSolicitudSalidaExtra.Herramientas.length==0 && this.ObjSolicitudSalidaExtra.Insumos.length==0) {
				Mensaje = 'Debe Seleccionar Al Menos Una Herramienta o Insumo';
                BndError=true;
			}

			if (BndError) {
				this.oBtnSave.DisableBtn = false;
                this.$toast.warning(Mensaje);
                return false;
            }

			let FechaRegistro = '';

			this.ObjSolicitudSalidaExtra.IdCotizacion = this.ObjCotizacion.IdCotizacion;
			this.ObjSolicitudSalidaExtra.IdCliente = this.ObjCotizacion.IdCliente;
			this.ObjSolicitudSalidaExtra.IdContacto = this.ObjCotizacion.IdContacto;
			this.ObjSolicitudSalidaExtra.IdAgente = this.ObjCotizacion.IdAgente;

            let formData=new FormData();
			formData.set('IdCotizacion',this.ObjSolicitudSalidaExtra.IdCotizacion);
			formData.set('IdCliente',this.ObjSolicitudSalidaExtra.IdCliente);
			formData.set('IdContacto',this.ObjSolicitudSalidaExtra.IdContacto);
			formData.set('IdAgente',this.ObjSolicitudSalidaExtra.IdAgente);
			formData.set('Folio',this.ObjSolicitudSalidaExtra.Folio);

			formData.set('IdMovimientoAlmacen',this.ObjSolicitudSalidaExtra.IdMovimientoAlmacen);
			formData.set('SalidaAsociada',this.ObjSolicitudSalidaExtra.SalidaAsociada);

			formData.set('IdUserElabora',this.ObjSolicitudSalidaExtra.IdUserElabora);
			formData.set('IdUserAutoriza',this.ObjSolicitudSalidaExtra.IdUserAutoriza);
			formData.set('IdUserEntrega',this.ObjSolicitudSalidaExtra.IdUserEntrega);
			formData.set('IdUserRecibe',this.ObjSolicitudSalidaExtra.IdUserRecibe);

			formData.set('FechaRegistro',FechaRegistro);
			formData.set('FechaEvento',this.FechaEvento);
			formData.set('Observaciones',this.ObjSolicitudSalidaExtra.Observaciones);
			formData.set('TipoSalida','Eventos');
			formData.set('Estatus','PendienteE');
			formData.set('FolioAsociado',this.pObjAsociado.Folio);

			formData.set('Herramientas',JSON.stringify(this.ObjSolicitudSalidaExtra.Herramientas));
			formData.set('Insumos',JSON.stringify(this.ObjSolicitudSalidaExtra.Insumos));
			// formData.set('Eventos',JSON.stringify(this.ListaEventos));
			formData.set('TipoGuardado',this.TipoGuardado);

            this.$http.post('/movimientosSalidaEx',formData
            ).then((res)=>{
                this.EjecutaConExito(res);
            }).catch((err)=>{
                this.EjecutaConError(err);
            })
        },
        EjecutaConExito(res)
		{
            this.oBtnSave.DisableBtn = false;  
            this.bus.$emit('RunAlerts_'+this.Emit,1);
			this.ObjSolicitudSalidaExtra.IdMovimientoAlmacen = res.data.data.IdMovimientoAlmacen;
			this.Recuperar();

            if(this.TipoGuardado == 'Definitivo'){
				this.Regresar();
			}
        },
        EjecutaConError(err)
		{
            this.oBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.oBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
        Recuperar()
		{
			this.$http.get(
                "movimientosAlmacen/"+this.ObjSolicitudSalidaExtra.IdMovimientoAlmacen
            ).then((res) => {
                this.ObjSolicitudSalidaExtra = res.data.data.SolicitudAlmacen;
				this.ObjSolicitudSalidaExtra.Herramientas = res.data.data.Herramientas;
				this.ObjSolicitudSalidaExtra.Insumos = res.data.data.Insumos;

            }).finally(()=>{
                this.ConfigLoad.ShowLoader = false;
				// this.bus.$emit('ArrayHerramientas');
				// this.bus.$emit('ArrayInsumos');
            });
        },
        Limpiar()
		{
			this.ObjSolicitudSalidaExtra = {
				IdMovimientoAlmacen: 0,
				IdCotizacion: 0,
				IdCliente: 0,
				IdContacto: 0,
				IdAgente: 0,
				IdEmpresa: 0,
				IdSucursal: 0,
				SalidaAsociada: 0,
				Folio: '',
				IdUserElabora: 0,
				IdUserAutoriza: 0,
				IdUserEntrega: 0,
				IdUserRecibe: 0,
				FechaEvento: '',
				FechaSalida: '',
				FechaRetorno: '',
				TipoSalida: '',
				Estatus: '',
				Observaciones: '',
				Materiales:[],
				Herramientas:[],
				Insumos:[]
            }
			this.ObjCotizacion={};
            this.errorvalidacion = [];
        },
        Regresar(){
            this.$router.push({name:this.oBtnSave.ReturnRoute});
        },
        RecuperarCotizacion()
		{
            this.$http.get('calendarioResumen/'+this.IdCotizacion,{
				params:{
					FechaEvento: this.FechaEvento
				}
			}).then((res)=>{

				this.ObjCotizacion = res.data.data;
				this.ListaEventos = res.data.eventos;
				this.ConfigLoad.ShowLoader = false;
				this.Vendedor = res.data.vendedor;
				this.Contacto = res.data.contacto;

				/* res.data.eventos.forEach(Evento => {
					let ElementosFaltantes=Evento.Elementos.filter((Elemento)=>{
						Elemento.Check = false;
						let Index = this.DetallesSolicitud.findIndex((El=>Elemento.IdDetalleCotizacion==El.IdCotizacionEventoDetalle))
						return Index!=-1 && this.DetallesSolicitud[Index].SalidaCheck!=1;
					});
					Evento.Elementos=ElementosFaltantes;
				});
				this.ListaEventos = res.data.eventos;
				this.ConfigLoad.ShowLoader = false; */
			})
        },
        GetUrlRutas(){
            this.$http.get(
                "solicitudGetRutas/"
            ).then((res) => {
                this.RutaFile = res.data.RutaGaleria;
                this.RutaAnexada = res.data.RutaAnexada;
                //this.RutaTemporal = res.data.RutaTemporal;

            }).finally(()=>{
            });
        },
		AbrirModalArticulo(Tipo)
		{
			if(Tipo == 'Herramientas')
			{
				this.bus.$emit('NewModal_'+this.ConfigModalHerramienta.EmitSeccion,this.ObjSolicitudSalidaExtra);
			}
			else
			{
				this.bus.$emit('NewModal_'+this.ConfigModalInsumo.EmitSeccion,this.ObjSolicitudSalidaExtra);
			}
		},
		AgregarArticuloAlmacen(item,Tipo)
        {
			console.log(item);
			let ObjLista = {
				IdArticuloAlmacen: item.IdArticuloAlmacen,
                IdCotizacionEvento: 0,
                IdCotizacionEventoDetalle: 0,
                Nombre: item.Nombre,
                Stock: item.Stock,
                CantidadSalida: item.CantidadSalida,
                Disabled: item.Disabled,
                Check: item.Check,
				TipoMaterial: item.TipoMaterial,
				ComentarioSalida: "",
            }
			console.log(ObjLista);

			// this.objMovimientoAlmacen.Herramientas.push(ObjLista);
			let existe = this.ObjSolicitudSalidaExtra[Tipo].find(e => e.IdArticuloAlmacen == item.IdArticuloAlmacen);            
        
			if (!existe) {
				// USAMOS PUSH, pero nos aseguramos de que el prop que va a los hijos se actualice
				this.ObjSolicitudSalidaExtra[Tipo].push(ObjLista);
				
				// TRUCO DE REACTIVIDAD: Forzamos a Vue a ver el cambio en el objeto
				this.ObjSolicitudSalidaExtra = { ...this.ObjSolicitudSalidaExtra };
				
				this.$toast.success(`${item.Nombre} agregado correctamente.`);
			}
        },
		EliminarArticuloAlmacen(Id,Tipo)
        {
			let index = this.ObjSolicitudSalidaExtra[Tipo].findIndex((element) => element.IdArticuloAlmacen == Id);
            this.ObjSolicitudSalidaExtra[Tipo].splice(index,1);
        },
    },
    created() {
        this.oBtnSave.Toast = 0;
        this.ConfigLoad.ShowLoader = true;

        this.bus.$off('EmitReturn');
        this.bus.$off('Save_'+this.Emit);
		this.bus.$off('AbrirModalArticulo');
		this.bus.$off('AgregarArticulosModal');
    },
    mounted()
    {
		this.oBtnSave.DisableBtn = false;
        // this.Limpiar();
		this.GetUrlRutas();

		this.ObjSolicitudSalidaExtra.SalidaAsociada = this.pObjAsociado.IdMovimientoAlmacen;
        

        if(this.IdMovimientoAlmacen > 0) 
        {
			// this.oBtnSave.ShowBtnSave=false;
            this.ObjSolicitudSalidaExtra.IdMovimientoAlmacen = this.IdMovimientoAlmacen;
			this.Recuperar();
			this.RecuperarCotizacion();
        }
		else
		{
			this.ConfigLoad.ShowLoader = true;
			this.RecuperarCotizacion();
		}
        // this.RecuperarDetalles();

        this.bus.$on('Save_'+this.ConfigList.EmitSeccion,()=>
        {
            this.Guardar();
        });

        this.bus.$on('EmitReturn',()=>
        {
            this.Regresar();
        });

		this.bus.$on('AbrirModalArticulo',(Tipo)=>
        {
            this.AbrirModalArticulo(Tipo);
        });

		this.bus.$on('AgregarArticulosModal',(obj,Tipo)=>{
            this.AgregarArticuloAlmacen(obj,Tipo);
        });
    }
}
</script>

<style>

</style>